import React from 'react';
import { ServiceWrapper } from './style'

const ServiceItem = ({ 
  item: {id, Name}, 
  onClick,
  selected,
  borderColor
}) => {
return (
    <ServiceWrapper 
        key={id}
        onClick={() => onClick(null, null, id)}
        selected={id === selected}
        borderColor={borderColor}
    >
        {Name}
    </ServiceWrapper>
)
};

export default ServiceItem;